import React from 'react';
import PropTypes from 'prop-types';
import Input from '@carvana/showroom-forms/Input';

const AccountNumberConfirm = props => {
  const {
    error,
    id,
    label,
    mode,
    name,
    onBlur,
    onChange,
    touched,
    value,
    ...rest
  } = props;

  return (
    <Input
      className="fs-exclude"
      label={label}
      id={id}
      onBlur={onBlur}
      onChange={onChange}
      touched={touched}
      error={error}
      value={value}
      name={name}
      mode={mode}
      maxLength="17"
      {...rest}
    />
  );
};

AccountNumberConfirm.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  label: PropTypes.string,
  mode: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  touched: PropTypes.bool,
  value: PropTypes.string.isRequired
};

AccountNumberConfirm.defaultProps = {
  error: false,
  id: 'accountNumberConfirm',
  label: 'Confirm Bank Account Number',
  mode: 'light',
  name: null,
  onBlur: () => {},
  onChange: () => {},
  touched: false
};

export default AccountNumberConfirm;
